export default __webpack_public_path__ + "static/blob-24-2cb58bd893eb7f7db8d2ccc0842d4c5c.svg";